import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { SurveyComponent } from "./survey.component";
import { PipeModule } from "app/pipes/pipe.module";
import { PhotoListSurveyFieldModule } from "app/client/components/photoListSurveyField/photoListSurvetField.module";


@NgModule({
  declarations: [
    SurveyComponent
  ],
  exports: [
    SurveyComponent
  ],
  imports: [
    PhotoListSurveyFieldModule,
    CommonModule,
    RouterModule,
    PipeModule
  ]
})
export class SurveyModule { }



// WEBPACK FOOTER //
// /app/SPA/src/app/client/components/survey/survey.module.ts